import { http } from '@pendo/http';

export function fetchStatus () {
    return http.get('/api/s/_SID_/blacklist/status').then((res) => res.data);
}
